import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'

export default {
  name: 'SemanticModal',
  components: {
    BliModal,
    BliButton,
    BliModalHeader,
    BliModalBody,
    BliModalFooter
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'info'
    },
    isLongAction: {
      type: Boolean,
      default: false
    },
    tertiaryButtonLabel: {
      type: String,
      default: ''
    },
    primaryButtonLabel: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  emits: ['closeModal', 'onPrimaryClick', 'onTertiaryClick']
}
